import {registerBlockType} from '@wordpress/blocks';
import './style.scss';
import edit from './edit';
import metadata from './block.json';
import {addFilter} from '@wordpress/hooks'
import {createHigherOrderComponent} from '@wordpress/compose'
import {Fragment, useState} from '@wordpress/element'
import {InspectorControls} from '@wordpress/block-editor'

import {
    __experimentalToggleGroupControl as ToggleGroupControl,
    __experimentalToggleGroupControlOptionIcon as ToggleGroupControlOptionIcon,
    __experimentalDivider as Divider,
    ExternalLink,
    PanelBody,
    Button,
    TextControl,
    ToggleControl,
    RangeControl,
    Spinner,
    Notice
} from '@wordpress/components'
import {column, columns} from '@wordpress/icons';
import apiFetch from '@wordpress/api-fetch';

registerBlockType(metadata.name, {

    attributes: {
        url: {
            type: 'string'
        },
        showTrailer: {
            default: true,
            type: 'bool'
        },
        showTV: {
            default: true,
            type: 'bool'
        },
        showDisc: {
            default: true,
            type: 'bool'
        },
        showNumbers: {
            default: false,
            type: 'bool'
        },
        hideEntryWithoutProvider: {
            default: false,
            type: 'bool'
        },
        type: {
            default: 'simple',
            type: 'string'
        },
        limit: {
            default: 1,
            type: 'number'
        },
        filterUrl: {
            default: '',
            type: 'string'
        },
        style: {
            default: 'single',
            type: 'string'
        },
        selectedProviders: {
            type: 'string',
            default: ''
        }
    },
    edit
});

const withInspectorControls = createHigherOrderComponent((BlockEdit) => {
    return (props) => {

        // Only apply to the specific block 'widget/werstreamtes'
        if (props.name !== 'widget/werstreamtes') {
            return (
                <BlockEdit {...props} />
            )
        }

        const {attributes, setAttributes} = props;

        const [providersLoaded, setProvidersLoaded] = useState(false);
        const [selectedProviders, setSelectedProviders] = useState(attributes.selectedProviders.split(",").filter(i => i).map(i => parseInt(i)));
        const [providers, setProviders] = useState([]);

        if (!providersLoaded) apiFetch({path: 'wse/getProviders'}).then((providers) => {
            setProvidersLoaded(true);
            setProviders(providers);
        });

        const isListUrl = url => {
            if (url.match('^https:\\/\\/www\\.werstreamt\\.es\\/(serie|filme)\\/details\\/\\d+\\/[\\w-]+\\/?$')) return false;
            if (url.match(/^https:\/\/www\.werstreamt\.es\/(filme-serien|serien|filme)\/(.+?)?$/) || url.match('^https:\\/\\/www\\.werstreamt\\.es\\/(filme|serien|filme-serien)(\\/(liste|wie)-\\d+\\/?)?$')) return true;
        }

        return (
            <>
                <BlockEdit {...props} />
                <InspectorControls>
                    <PanelBody title="Allgemeine Einstellungen" initialOpen={true}>
                        <TextControl
                            autocomplete="off"
                            label="URL zum Film, Serie oder Liste"
                            value={attributes.filterUrl}
                            onChange={(URL) => {
                                setAttributes({filterUrl: URL});
                            }}
                        />
                        {attributes.filterUrl ? (
                            <ExternalLink href={attributes.filterUrl}>WerStreamt.es durchsuchen</ExternalLink>
                        ) : ""}
                    </PanelBody>
                    {attributes.filterUrl && isListUrl(attributes.filterUrl) ?
                        (
                            <PanelBody title="Listen Einstellungen">
                                <ToggleGroupControl label="Darstellung" value={attributes.style} isBlock
                                                    onChange={(newValue) => {
                                                        setAttributes({style: newValue})
                                                    }}>
                                    <ToggleGroupControlOptionIcon value="single" label="Einspaltig" icon={column}/>
                                    <ToggleGroupControlOptionIcon value="double" label="Zweispaltig" icon={columns}/>
                                </ToggleGroupControl>
                                <RangeControl
                                    label="Wie viele Einträge sollen angezeigt werden?"
                                    value={attributes.limit}
                                    step={attributes.style === "double" ? 2 : 1}
                                    min={attributes.style === "double" ? 2 : 1}
                                    max={50}
                                    onChange={(newValue) => {
                                        setAttributes({limit: newValue});
                                    }}
                                />
                                <ToggleControl
                                    label="Nummerierung anzeigen?"
                                    checked={attributes.showNumbers}
                                    onChange={(newValue) => {
                                        setAttributes({showNumbers: newValue});
                                    }}
                                />
                                <ToggleControl
                                    label="Einträge ohne Anbieter ausblenden"
                                    checked={attributes.hideEntryWithoutProvider}
                                    onChange={(newValue) => {
                                        setAttributes({hideEntryWithoutProvider: newValue});
                                    }}
                                    __nextHasNoMarginBottom
                                />
                            </PanelBody>
                        ) :
                        (<></>)
                    }

                    <PanelBody
                        title={`Anbieter ${selectedProviders.length > 0 ? `(${selectedProviders.length} ausgewählt)` : ""}`}
                        initialOpen={false}>
                        <Notice status="info" isDismissible={false}>Standardmäßig werden alle Anbieter angezeigt. Hier können bei Bedarf einzelne Anbieter ausgewählt werden, die angezeigt werden sollen.</Notice>
                        <Divider />
                        {!providersLoaded ? (<Spinner/>) : providers.map(provider => {
                            const currentPosition = selectedProviders.indexOf(provider.alias);
                            return (
                                <ToggleControl
                                    __nextHasNoMarginBottom
                                    label={provider.title}
                                    checked={currentPosition > -1}
                                    onChange={() => {

                                        if (currentPosition > -1) {
                                            selectedProviders.splice(currentPosition, 1);
                                        } else {
                                            selectedProviders.push(provider.alias);
                                        }

                                        setSelectedProviders(selectedProviders);
                                        setAttributes({selectedProviders: selectedProviders.join(",")});
                                    }}
                                />
                            );
                        })}

                        {selectedProviders.length > 0 ? (
                            <>
                                <Divider/>
                                <Button variant="tertiary" onClick={() => {
                                    setSelectedProviders([]);
                                    setAttributes({selectedProviders: ""});
                                }}>{selectedProviders.length} Anbieter abwählen</Button>
                            </>
                        ) : ""}

                    </PanelBody>

                </InspectorControls>
            </>
        );
    }
}, 'withInspectorControls')

addFilter(
    'blocks.registerBlockType',
    'extending-gutenberg/add-attributes',
    (props, name) => {
        if (name !== 'core/heading') {
            return props
        }

        const attributes = {
            ...props.attributes,
            extendedSettings: {
                type: 'object',
                default: {
                    URL: null
                },
            }
        }

        return {...props, attributes}
    }
)

addFilter(
    'editor.BlockEdit',
    'extending-gutenberg/edit',
    withInspectorControls
);